// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Q6-z"};